import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var AirlineSeatLegroomExtra = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3H2v14h11v-2H4zm18.24 12.96-2.53 1.15-3.41-6.98A2.019 2.019 0 0 0 14.51 9H11V3H5v11h10l3.41 7 5.07-2.32-1.24-2.72z"
  }));
});
AirlineSeatLegroomExtra.displayName = 'AirlineSeatLegroomExtra';
export var AirlineSeatLegroomExtraDimensions = {
  height: 24,
  width: 24
};